import Typography from '@mui/material/Typography';
import { inputStyles } from 'core/utilities/styles/input.styles';
import { sx } from 'core/utilities/theme';
import type React from 'react';

interface ComponentProps {
  children: React.ReactNode;
}

function InputModalLabel({
  children,
}: ComponentProps) {
  const styles = inputStyles({
    modalLabel: true,
  });

  return (
    <Typography sx={sx(styles.labelRoot, { mt: 1 })}>
      {children}
    </Typography>
  );
}

export default InputModalLabel;
